import remoteLoad from '@/utils/remoteLoad.js';

export default {
  data() {
    return {
      // 报名活动的ID
      signupNoticeId: this.$route.query.signupNoticeId,
      // 预报名号
      teacherSignupId: this.$route.query.teacherSignupId,
      // 幼儿身份证号
      idCard: this.$route.query.idCard,
      applyData: null,
      errMessage: ''
    };
  },
  async mounted() {
    this.ajaxSearchSignupApplyInfo({
      teacherSignupId: this.teacherSignupId,
      idCard: this.idCard
    });
  },
  created() {
  },
  methods: {
    async ajaxSearchSignupApplyInfo(params) {
      // 查询报名信息 #李茹钰/2019-03-12#
      let { error, data } = await this.$ajax.gateway('/bm-teacher/ITeacherSignupApi_searchApply', params);
      console.log('-> data data', error, data);
      if (!error && data.code === 200) {
        data = data.data;
        console.log('-> 查询报名信息', data);
        this.applyData = data;
      }
    },
    onClickChangeBtn() {
      // 修改报名信息
			sessionStorage.removeItem('autoPushStep');
			// 更新最新的预约时间
			sessionStorage.setItem('form_orderDate', this.applyData.orderDate);
      this.$router.push({
        path: 'bm_form',
        query: {
          signupNoticeId: this.signupNoticeId,
          teacherSignupId: this.teacherSignupId,
					idCard: this.idCard,
					orderDate: this.applyData.orderDate
        }
      });
    }
  }
};
